


























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import PrescriptionPatientResume from '@/components/prescription/resume/patient-resume.vue';
import PrescriptionGeneralResume from '@/components/prescription/resume/general-resume.vue';
import PrescriptionValidationMessages from '@/components/prescription/validation-messages.vue';
import PrescriptionResumeProducts from '@/components/prescription/resume/products-resume.vue';
import PrescriptionFormUpdateStatus from '@/components/prescription/form/update-status.vue';
import PrescriptionTranscriptionModalList from '@/components/prescription/transcription/modal-list.vue';
import PrescriptionModel from '@/models/prescription-model';
import * as service from '@/services/prescription';
import { toNumber } from '@/helpers/toNumber';
import { decimalFormat } from '@/helpers/decimalFormat';
import IProduct from '@/interfaces/product';
import {
  isWaitingPharmaceuticalApprove,
  isDenied,
  isSentToProduction,
  isErrorOnSentToProduction,
} from '@/helpers/validatePrescriptionStatus';
import { isWaitingTranscriptionApprove } from '@/helpers/validateTranscriptionStatus';
import { TRANSCRIPTION_PHARMACEUTICAL } from '@/settings/consts/transcriptions-types';
import * as transcriptionStatus from '@/settings/consts/transcription-status';
import TranscriptionModel from '@/models/transcription-model';

@Component({
  components: {
    PermissionAuth,
    PrescriptionPatientResume,
    PrescriptionGeneralResume,
    PrescriptionValidationMessages,
    PrescriptionResumeProducts,
    PrescriptionFormUpdateStatus,
    PrescriptionTranscriptionModalList,
  },
})
export default class PrescriptionTranscriptionDiff extends BaseComponent {
  @Prop()
  public items: PrescriptionModel[];
  @Prop()
  public transcription: TranscriptionModel;

  public selectedTranscriptions: PrescriptionModel[] = [];
  public transcriptions: PrescriptionModel[] = [];
  public modalListIsOpen: boolean = false;

  @Watch('items')
  public onItemsChange(val: PrescriptionModel[]): void {
    const emptyTranscription = new PrescriptionModel();
    this.selectedTranscriptions = [emptyTranscription, emptyTranscription];

    this.transcriptions = cloneDeep(val);
    if (!!this.transcriptions.length) {
      setTimeout(() => {
        this.openModalList();
      }, 200);
    }
  }

  public closeForm(): void {
    this.selectedTranscriptions = [];
    this.$emit('close');
  }

  public onEdit(item: PrescriptionModel): void {
    const payload = cloneDeep(item);
    payload.idTranscricao = this.transcription.id;
    payload.idPrescricao = null;
    payload.tipoTranscricao = TRANSCRIPTION_PHARMACEUTICAL;
    payload.transcriptionCopy = true;
    this.$emit('edit', payload);
  }

  public isWaiting(transcription: TranscriptionModel): boolean {
    return (
      transcription.status !== transcriptionStatus.TRANSCRIPTION_APPROVED.key &&
      transcription.status !==
        transcriptionStatus.TRANSCRIPTION_ERROR_ON_SEND_TO_PRODUCTION.key &&
      transcription.status !== transcriptionStatus.TRANSCRIPTION_DENIED.key
    );
  }

  public openModalList(): void {
    this.modalListIsOpen = true;
  }

  public closeModalList(): void {
    this.modalListIsOpen = false;

    const transcriptionsIsEmpty = () =>
      !this.selectedTranscriptions.length ||
      this.selectedTranscriptions.some((item) => !item.idPrescricao);
    if (transcriptionsIsEmpty()) {
      this.closeForm();
    }
  }

  public onUpdateSatatus(): void {
    this.selectedTranscriptions = [];
    this.$emit('close');
    this.$emit('reload');
  }

  public onSelectTranscriptions(transcriptions: PrescriptionModel[]): void {
    if (!transcriptions.length) {
      this.closeForm();
      return;
    }

    this.modalListIsOpen = false;

    transcriptions = transcriptions.map((item) => {
      item.unidade = {
        ...item.unidade,
        cliente: item.cliente,
      };

      /*
      const products = item.produtos.map((item) => {
        return {
          idProduto: item.id,
          unidades: item.unidadeMedidasProduto.filter(
            (itemUnit) => !!itemUnit.digitado,
          ),
        };
      });

      item.produtos = item.produtos.map((product) => {
        if (!!product.unidades.length) {
          product.unidades[0].digitado = true;
        }
        if (!!product.unidadeMedidasProduto.length) {
          product.unidadeMedidasProduto[0].digitado = true;
        }

        const infusionTime = item.tempoInfusao;
        const volumeTotal = item.volumeDesejado;
        const weight = item.paciente.peso;

        const payload = {
          infusionTime,
          volumeTotal,
          weight,
          products,
        };

        this.unitsCalculate(
          payload,
          product.unidades[0],
          product.id,
          item.idPrescricao,
        );
        return product;
      });
      */
     
      this.selectedTranscriptions.forEach(t => {
        t.produtos.forEach(p=>{
          p.unidadeMedidasProduto = p.unidades;
        });
        t.produtos = cloneDeep(t.produtos);
        t.calcTypedVolume();
      })
      item.produtos = cloneDeep(item.produtos);
      item.calcTypedVolume();
      this.selectedTranscriptions = cloneDeep(transcriptions);
      
      item.idTranscricao = this.transcription.id;
      return item;
    });
    this.selectedTranscriptions = cloneDeep(transcriptions);
  }

  public disableActionsArea(
    status: string,
    transcriptionStatus: string,
  ): boolean {
    return (
      isDenied(status) ||
      isSentToProduction(status) ||
      isErrorOnSentToProduction(status) ||
      (!isWaitingPharmaceuticalApprove(status) &&
        isWaitingTranscriptionApprove(transcriptionStatus))
    );
  }

  private unitsCalculate(
    transcriptionInfos: any,
    unit: any,
    productId: string,
    trascriptionId: string,
  ): void {
    const payload = {
      valor: unit.valor,
      idUnidadeMedida: unit.id,
      pesoPaciente: transcriptionInfos.weight,
      volumeBolsaMl: transcriptionInfos.volumeTotal,
      tempoInfusao: transcriptionInfos.infusionTime,
      glicosePrescricao: transcriptionInfos.glicoseTotal,
      produtos: transcriptionInfos.products,
    };

    service.unitsConversion(productId, payload).subscribe((data) => {
      this.selectedTranscriptions.map((transcription) => {
        if (transcription.idPrescricao === trascriptionId) {
          const products = transcription.produtos.map((product) => {
            if (product.id === productId) {
              const units = data.unidades.map((itemUnit) => {
                const typedUnit = product.unidadeMedidasProduto.find(
                  (item) => item.id === itemUnit.id,
                );

                return {
                  ...itemUnit,
                  digitado: !!typedUnit,
                  valor: toNumber(decimalFormat(itemUnit.valor), true),
                };
              });
              product.unidadeMedidasProduto = units;
              product.unidades = units;
            }
            return product;
          });
          transcription.produtos = cloneDeep(products);
        }

        transcription.calcTypedVolume();
        return transcription;
      });
    });
  }
}
